<template>
  <tbody>
  <tr :class="[{'more_info': $_updateActionAllowed}, { open: isOpen }]" @click="toggleMoreInfo()">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <span
          v-if="!$_updateActionAllowed"
          class="lock"
          :title="'Uzamknuto' | translate"
          v-translate>
      </span>
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <td :data-th="'Název štítku' | translate">
      {{ entity.name }}
    </td>
    <td :data-th="'Operátor' | translate">
      <entity-link :id="entity.id_operator" type="operator">{{ entity.operator_name }}</entity-link>
    </td>
    <td :data-th="'Počet plátců' | translate">{{ entity.billers_count }}</td>
    <td :data-th="'Počet odběratelů' | translate">{{ entity.subscribers_count }}</td>
    <td :data-th="'Vytvořeno' | translate" v-html="$_date_format(entity.date_created)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="$_deleteActionAllowed"
            class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteTag">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
  <tr v-if="$_updateActionAllowed" :class="['more_info_content', { open: isOpen }]">
    <td></td>
    <td></td>
    <td class="first_data">
      <text-input
          :id="'tag-name-'+entity.id"
          v-model="entity.name"
          :required="true"
          ref="tagnameref">
        <translate class="translate">Název štítku</translate>
      </text-input>
    </td>
    <td></td>
    <td></td>
    <td></td>
    <td><p>
      <input
          class="btn"
          type="submit"
          :value="'Uložit' | translate"
          @click.stop.prevent="emitUpdateTag">
    </p></td>
    <td class="first_data"><p></p></td>
  </tr>
  </tbody>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"
import EntityLink from "../../common/EntityLink.vue";

export default {
  name: "TagsRow",
  components: { EntityLink },
  mixins: [rowActions],
  data: function () {
    return {
      isOpen: false
    }
  },
  props: {
    entity: Object,
  },
  methods: {
    toggleMoreInfo() {
      if (this.$_updateActionAllowed) {
        this.isOpen = !this.isOpen
        if (this.isOpen) {
          this.resetInput('tagnameref')
        }
      }
    },
    resetInput(ref) {
      this.$refs[ref].setForcedInvalid(false)
      this.$refs[ref].setTouched(false)
    },
    hideMoreInfo() {
      this.isOpen = false
    },
    emitDeleteTag() {
      this.$emit('deleteTag', String(this.entity.id))
    },
    emitUpdateTag() {
      let data = {
        id: this.entity.id,
        params: {name: this.entity.name}
      }
      this.$emit('updateTag', data)
      this.hideMoreInfo()
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/tags/TagRow.vue